<template>
  <modal class="q-modal logout-alert" name="logout-modal-alert" :class="ifTop"
      transition="nice-modal-fade"
      :width="425"
      :min-width="425"
      :height="'auto'"
      :delay="100"
      :draggable="'.modal-header'"
      :clickToClose="false"
      :adaptive="true"
      @opened="Opened"
      classes='q-v--modal'>
    <div class="modal-content">
      <div class="modal-body">
        <div class="modal-container">
          <div class="message">
            {{$t('login.logoutAuto', sec)}}
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="footer-left">
        </div>
        <div class="footer-right">
          <button class="q-button" @click="onClose()">{{$t('ok')}}</button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
export default {
  props: {
    onChange: Function
  },
  data () {
    return {
      sec: 5,
      interval: null
    }
  },
  methods: {
    Opened (event) {
      this.interval = setInterval(() => {
        if (this.sec === 0) {
          this.onClose()
        }
        this.sec--
      }, 1000)
    },
    onClose () {
      this.closeModal('logout-modal-alert')
      this.$modal.hide('logout-modal-alert')
      this.onChange()
      clearInterval(this.interval)
    },
    ...mapMutations([
      'openModal',
      'closeModal'
    ]),
    ...mapActions(['postLogout'])
  },
  computed: {
    ...mapState(['count', 'modalList']),
    ...mapGetters(['getTopModalName']),
    ifTop () {
      this.$log.debug('this.getTopModalName :' + this.getTopModalName)
      if (this.getTopModalName !== this.modalname) {
        return 'noTopModal'
      } else {
        return 'none'
      }
    }
  }
}
</script>
<style lang="scss" scoped>

@import '../assets/scss/modal.scss';
.logout-alert {
  .message {
    margin: 20px 0px 0px 0px !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/LogoutWarning.vue